import React from 'react';

import messages from '../../messages';
import BetslipModal from '../BetslipModal';
import useAcceptOddsChangeModal from './useAcceptOddsChangeModal';

import settingsGlyph from 'assets/svg/setting-betslip.svg';

const AcceptOddsChangeModal: React.FC = () => {
    const {
        handleCancel,
        handleSkip,
        handleSubmit,
        isModalOpen,
    } = useAcceptOddsChangeModal();

    if (!isModalOpen) return null;

    return (
        <BetslipModal
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
            handleClick={handleSkip}
            iconMessage={settingsGlyph}
            title={messages.oddsChanged}
            subTitle={messages.acceptAllQuestion}
            cancelTextBtn={messages.declineButton}
            subTextBtn={messages.skipButton}
            message={messages.oddsStrategyHelpInfo}
            submitTextBtn={messages.acceptButton}
        />
    );
};

export default AcceptOddsChangeModal;
